// extracted by mini-css-extract-plugin
module.exports = {"ButtonContainer":"ConfirmationInstructions_ButtonContainer__3k72G","BackToLoginButton":"ConfirmationInstructions_BackToLoginButton__3sT9i"};